export function daysToMonth (days) {
  const daysEachMonth = 30
  let months = Math.floor(days / daysEachMonth)

  if (months > 12) { months = Math.floor(months / 12) }

  return months
}
